import React from 'react';
import { Label } from 'reactstrap';

const FormLabel = (props) => {
    const { children, ...rest } = { ...props };
    return <Label {...rest}>
        <b>{children}</b>
    </Label>
}

    const FormValue = (props)=>{
    const {children, ...rest } = {...props};
    return <Label {...rest}>
                {children}
    </Label>
}

export {FormLabel, FormValue}